module.exports = __webpack_public_path__ + "img/icon-hal.528889ac.svg";